import { IconWithCount } from '~/components/Icon';
import carriers, { carrierRebrandMap } from '~/constants/carriers';

type Props = {
  provider: string;
  count?: number;
  className?: string;
  size?: string;
  badgeSize?: string;
};

const CarrierIcon = ({ provider, count, className, size, badgeSize }: Props) => {
  // See https://shippo.atlassian.net/browse/ENG-29904
  if (carrierRebrandMap[provider]) {
    provider = carrierRebrandMap[provider];
  }
  const icon = carriers.find((x) => x.name === provider)?.icon;
  const sizeOrDefault = size || '40px';
  return (
    <IconWithCount
      className={className}
      src={icon!}
      alt=""
      count={count}
      size={sizeOrDefault}
      badgeSize={badgeSize}
    />
  );
};

export default CarrierIcon;
